import classnames from 'classnames'

import styles from './index.module.scss'

const PageContainer = ({ className, children, ...rest }) => {
  return (
    <div className={classnames(styles.pgContainer, className)} {...rest}>
      {children}
    </div>
  )
}

export default PageContainer
